export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReENVW5pR0ItVVRGMzItSEMRAAAgFIRWEQCfWjEAAxDvNoOdbe8xCgsB7zoOAAHvMxvvMgEAAe8NGwkBAADvBIEEDGMGAAAwCAeESAABhFICAYRGAAGEUIOdcAGERBABhEA=", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/UniGB-UTF32-V.bcmap
// module id = 699
// module chunks = 502